var map = {
	"./3d.svg": 604,
	"./ant.svg": 605,
	"./arrow-up.svg": 606,
	"./backend.svg": 607,
	"./banner-left.svg": 608,
	"./banner-right.svg": 609,
	"./bigname.svg": 610,
	"./bold.svg": 611,
	"./bulleted-list.svg": 612,
	"./checkbox-checked.svg": 613,
	"./checkbox-interminate.svg": 614,
	"./chevron-right.svg": 615,
	"./close-border.svg": 616,
	"./close.svg": 617,
	"./code.svg": 618,
	"./compress.svg": 619,
	"./copy.svg": 620,
	"./design.svg": 621,
	"./desktop.svg": 622,
	"./down-load.svg": 623,
	"./emoji.svg": 624,
	"./empty-plugin.svg": 625,
	"./empty-universe-dark.svg": 626,
	"./empty-universe-light.svg": 627,
	"./empty-user-none-dark.svg": 628,
	"./empty-user-none-light.svg": 629,
	"./empty-user-share-dark.svg": 630,
	"./empty-user-share-light.svg": 631,
	"./expand.svg": 632,
	"./eye.svg": 633,
	"./feed.svg": 634,
	"./group-code.svg": 635,
	"./guide.svg": 636,
	"./h1.svg": 637,
	"./heart-border.svg": 638,
	"./heart-red.svg": 639,
	"./illustration.svg": 640,
	"./interface.svg": 641,
	"./ipad.svg": 642,
	"./italic.svg": 643,
	"./like-active.svg": 644,
	"./like.svg": 645,
	"./link.svg": 646,
	"./logo_dark.svg": 647,
	"./logo_light.svg": 648,
	"./no-save-dark.svg": 649,
	"./no-save-light.svg": 650,
	"./ordered-list.svg": 651,
	"./other.svg": 652,
	"./plugin-none-dark.svg": 653,
	"./plugin-none-light.svg": 654,
	"./plugin-playground.svg": 655,
	"./profile-top.svg": 656,
	"./prototype-tag.svg": 657,
	"./qrcode-dark.svg": 658,
	"./qrcode-light.svg": 659,
	"./qzone.svg": 660,
	"./report.svg": 661,
	"./search.svg": 662,
	"./share-button.svg": 663,
	"./share.svg": 664,
	"./strikethrough.svg": 665,
	"./warning.svg": 666,
	"./wechat.svg": 667,
	"./weibo.svg": 668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 603;